"use strict";

exports.__esModule = true;
exports.formatNumber = formatNumber;

function formatNumber(value) {
  return new Intl.NumberFormat('de-DE').format(value);
}